import React from 'react';
import './Heading.scss';
import { Button } from '@components/Button';
import classNames from 'classnames';

interface HeadingProps {
  state?: 'left' | 'center';
  headline: string;
  intro: string;
  showButton?: boolean;
  buttonLabel?: string;
  buttonLink?: string;
}

export const Heading = ({
  state = 'left',
  headline,
  intro,
  showButton = false,
  buttonLabel,
  buttonLink,
}: HeadingProps) => {
  return (
    <div
      className={classNames('l-section', 'l-section-100', 'news-heading', {
        'is-center': state === 'center',
      })}>
      <h1 className='al-break-word'>{headline}</h1>
      <div className='news-intro'>
        <p className='font-light-x-lg-lh-150'>{intro}</p>
      </div>
      {showButton && <Button text={buttonLabel} href={buttonLink} size='small' color='primary' />}
    </div>
  );
};
